import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../config/config';
import { ResponsePackage } from '../models/util.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AiUploadBatchObjectsService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, private config: AppConfig) {
    this.pathApi = this.config.setting['pathApi'] + 'batchUploadObjects/';
  }

  getSegmentationData(): Observable<any> {
    return this.http.get(`${this.pathApi}getSegmentationData`, {
      headers: this.headers,
      observe: 'response',
    })
  }

  getall(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, obj, {
      headers: this.headers,
      observe: 'response',
    })
  }
  getMapDetails(id: number) {
    return this.http.get<ResponsePackage<any>>(`${this.pathApi}getMapDetails/${id}`, { headers: this.headers, observe: 'response' });
  }
}